import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { allArticles } from '@/mocks/articles';

export default function KakobuyVsCSSBuy() {
  const article = allArticles.find((a) => a.slug === 'kakobuy-vs-cssbuy')!;
  return (
    <>
      <Navbar />
      <main className="pt-20 md:pt-24">
        <ArticleLayout article={article} />
      </main>
      <Footer />
    </>
  );
}